import React, {useState} from 'react'
import Table from '.'
import PropTypes from 'prop-types'
import moment from 'moment'
import Modal from '../modal';
import { useModalWithUniqueId } from '../../hooks/modal';



export const WebhookTable = ({ data, size }) => {

    const [activeWebhookModalId, toggleWebhookModal] = useState(null);

    const fixPayload = (payload) => {
        try {
            return <pre>{JSON.stringify(JSON.parse(payload.replaceAll("'", '"').replaceAll("None", "null").replaceAll('True', 'true').replaceAll("False", 'false')), null, 2)}</pre>
        } catch (e) {
            return payload
        }
    }

    const columns = React.useMemo(
        () => [
            {
                Header: gettext('Date / time'),
                accessor: 'created_at',
                Cell: ({value, row}) => {
                    return (
                    <>
                        {moment(value).format("DD.MM.yy/hh:mm")}
                        <Modal
                            show={activeWebhookModalId === row.original.id}
                            showCancelButton={false}
                            onClick={() => {toggleWebhookModal(null)}}
                            onClose={() => toggleWebhookModal(null)}
                            confirmButtonText={gettext('Close')}
                            title={gettext('Webhook')}
                        >
                            {fixPayload(row.original.payload)}
                        </Modal>
                    </>);
                }
            },
            {
                Header: gettext('Path'),
                accessor: 'url',
                Cell: ({value, row}) => {
                    return (
                    <>
                        <a  href="javascript:void(0)" role="button" onClick={()=> toggleWebhookModal(row.original.id)}>{value}</a>
                    </>);
                }
            },
            {
                Header: gettext('Result'),
                accessor: 'result',
                className: "text-right",
            }
        ])

    return (<Table columns={columns} data={data} size={size} />)
}

WebhookTable.propTypes = {
    data: PropTypes.array,
    size: PropTypes.string
};
  
WebhookTable.defaultProps = {
    data: [],
    size: 'md'
};